import React, { Component } from 'react';
import { Label, Icon } from 'semantic-ui-react'

import CollapsibleCard from '../components/collapsible_card'
import NewEntryModal from './new_entry_modal'
import { initNewWorkPhaseEntry, initNewActivityEntry, initNewHazardEntry, initNewUnwantedEventEntry } from '../helpers/risk_helpers';

class AdminRiskCards extends Component {
  constructor(props){
    super(props)

    this.state = {
      risksTree: props.risksTree,
      risks: props.risks,
      activeSteps: [],
      languageName: props.languageName,
      showNewEntryForm: false
    }
  }

  componentWillReceiveProps = (nextProps) => {
    this.setState({
      risksTree: nextProps.risksTree,
      risks: nextProps.risks,
      languageName: nextProps.languageName
    })
  }

  toggleActivity = (activity) => {
    this.props.onToggleActivity(activity)
  }

  isActivityActive = (activity) => {
    return (this.props.activeCards.filter(card => card === activity).length > 0)
  }

  onSubmitEntry = (risk) => {
    this.toggleNewEntryForm(false)
    this.props.createRisk(risk)
  }

  toggleNewEntryForm = (show) => {
    this.setState({ showNewEntryForm: show })
  }

  createCards = () => {
    var { risksTree } = this.state
    const { work_phase_or_ambient_exposure, activity: activityText, new: new_label } = this.props.translations
    var cards = []

    for(var index in risksTree) {
      var workPhase = risksTree[index]
      var cardId = risksTree[index]["ids"][0]

      for(var activityIndex in risksTree[index].activities) {
        let activity = risksTree[index].activities[activityIndex]
        var hidden = null

        for(var hazardIndex in activity.hazards) {
          var hazard = activity.hazards[hazardIndex]

          for(var eventIndex in hazard.unwanted_events) {
            var unwanted_event = hazard.unwanted_events[eventIndex]

            if(unwanted_event.hidden !== null) {
              if (hidden === null){
                hidden = unwanted_event.hidden
              }
              else {
                hidden = hidden || unwanted_event.hidden
              }
            }
          }
        }
      }

      const template_flags = { is_work_phase_added: false, is_activity_added: true, is_hazard_added: true, is_unwanted_event_added: true }
      const newActivityRisk = initNewActivityEntry({ ...workPhase.metadata, hidden: null, template_flags })

      var content = this.createActivities(risksTree[index].activities, workPhase)

      cards = cards.concat(
        <CollapsibleCard
          expand={ this.isActivityActive(workPhase.translations["English"]) }
          onToggle={ (workPhase) => this.toggleActivity(workPhase) }
          key={ cardId }
          toggleKey={ workPhase.translations["English"] }
          headerLabel={ work_phase_or_ambient_exposure }
          headerText={ workPhase.translations["English"] }
          content={ content }
          className={ "work-phase" }
          newEntry={ {risk: newActivityRisk, name:activityText, callback: this.onSubmitEntry } }
          translations={this.props.translations}
          permission={this.props.permission}
          isTemplate
        />
      )
    }
    
    if(!this.props.instanceConfig.enable_workphase_addition || risksTree.length===0) return cards
  
    const template_flags = { is_work_phase_added: true, is_activity_added: true, is_hazard_added: true, is_unwanted_event_added: true }
    const newWorkPhaseRisk = initNewWorkPhaseEntry({ hidden: null, template_flags })

    cards.push(
      <div className="collapsible" key='new_work_phase_card'>
        <div className="collapsible header" onClick={ () => this.toggleNewEntryForm(true) }>
          <div>
            <div className="collapsible-new-entry">
              <a className="collapsible-new-entry">
                <Icon name="plus"/>
                { new_label + " " + work_phase_or_ambient_exposure }
              </a>
            </div>
          </div>
          {
            this.state.showNewEntryForm &&
            <NewEntryModal
              headerText={ new_label + " " + work_phase_or_ambient_exposure }
              shown={ this.state.showNewEntryForm }
              risk={ newWorkPhaseRisk }
              onSubmit={this.onSubmitEntry}
              onClose={ () => this.toggleNewEntryForm(false) }
              translations={this.props.translations}
              isTemplate
            />
          }
        </div>
      </div>
    )
    
    return cards
  }

  createActivities = (activities, workPhase) =>  {
    var cards = []

    for(var index in activities) {
      var activity = activities[index]
      var hidden = null

      for(var hazardIndex in activity.hazards) {
        var hazard = activity.hazards[hazardIndex]

        for(var eventIndex in hazard.unwanted_events) {
          var unwanted_event = hazard.unwanted_events[eventIndex]

          if(unwanted_event.hidden !== null) {
            if (hidden === null){
              hidden = unwanted_event.hidden
            }
            else {
              hidden = hidden || unwanted_event.hidden
            }
          }
        }
      }

      const template_flags = { is_work_phase_added: false, is_activity_added: false, is_hazard_added: true, is_unwanted_event_added: true }
      const newHazardRisk = initNewHazardEntry({...activity.metadata, hidden: null, template_flags })

      var content = this.createHazard(activity.hazards, workPhase, activity)
      const activity_label = this.props.translations.activity
      const hazard_label = this.props.translations.hazard
      cards = cards.concat(
        <CollapsibleCard
          key={ activity.translations["English"] }
          headerLabel={ activity_label } //was 'Step in Process', renamed as requested by the client
          headerText={ activity.translations["English"] }
          content={ content }
          className={ "activity" }
          newEntry={ {risk: newHazardRisk, name:hazard_label, callback: this.onSubmitEntry } }
          translations={this.props.translations}
          permission={this.props.permission}
          isTemplate
        />
      )
    }

    return cards
  }

  createHazard = (hazards, workPhase, activity) => {
    var cards = []

    for(var index in hazards) {
      var hazard = hazards[index]
      var hidden = null

      for(var eventIndex in hazard.unwanted_events) {
        var unwanted_event = hazard.unwanted_events[eventIndex]

        if(unwanted_event.hidden !== null) {
          if (hidden === null){
            hidden = unwanted_event.hidden
          }
          else {
            hidden = hidden || unwanted_event.hidden
          }
        }
      }

      const template_flags = { is_work_phase_added: false, is_activity_added: false, is_hazard_added: false, is_unwanted_event_added: true }
      const newUnwantedEventRisk = initNewUnwantedEventEntry({ ...hazard.metadata, hidden: null, template_flags })
      var content = this.createUnwantedEvent(hazard.unwanted_events)

      const unwanted_event_label = this.props.translations.unwanted_event
      const hazard_label = this.props.translations.hazard
      cards = cards.concat(
        <CollapsibleCard
          key={ hazard.translations["English"] }
          headerLabel={ hazard_label }
          headerText={ hazard.translations["English"] }
          content={ content }
          className={ "hazard" }
          newEntry={ {risk: newUnwantedEventRisk, name:unwanted_event_label, callback: this.onSubmitEntry } }
          translations={this.props.translations}
          permission={this.props.permission}
          isTemplate
        />
      )
    }

    return cards
  }

  createUnwantedEvent = (unwantedEvents) => {
    var { languageName } = this.props

    return unwantedEvents.map((unwanted_event, index) => {
      return (
        <div className="collapsible" key={ unwanted_event.translations["English"] + "_" + index }>
          <div className="collapsible header">
            <div className="collapsible-header-label">
              <Label className="text unwanted-event">{this.props.translations.unwanted_event}</Label>
            </div>
            <div className="collapsible-header-text">
              { unwanted_event.translations[languageName] }
            </div>
          </div>
        </div>
      )
    })
  }

  render() {
    return (
      <div className="cards-div">
        <div className="cards-area">
          { this.createCards() }
        </div>
      </div>
    )
  }
}

export default AdminRiskCards;



// WEBPACK FOOTER //
// ./src/components/admin_cards.js